
    import axios, { AxiosResponse } from 'axios';
    import { defineComponent } from 'vue';
    import ownCaptchaComponent from '../Shared/OwnCaptcha.vue';
    import { Field, Form, ErrorMessage, useForm } from 'vee-validate';
    import * as yup from 'yup';
    import { String as StringS } from 'typescript-string-operations';
    import { ClientJS } from "clientjs";

    export class DCRegisterResult {
        public  isregister: boolean = false;
        public  errorregister: string = "";
    }

    export default defineComponent({
        components: { ownCaptchaComponent, Field, Form, ErrorMessage },
        props: {
            modejetable: Boolean,
            langcurrent: String,
            captchapublickey: String,
            dclang_registerpseudo: String,
            dclang_registerpassword: String,
            dclang_registerpasswordverif: String,
            dclang_registeremail: String,
            dclang_registerbut: String,
            dclang_registerjetablebut: String,
            dclang_apply: String,
            create_account_desc_tempaccount: String,
            view_register_validate_requis: String,
            view_register_validate_tropchars: String,
            view_register_validate_minimumchars: String,
            view_register_validate_letternum: String,
            view_register_validate_passdifferent: String,
            view_register_validate_emailinvalid: String,
            view_migrateaccount_mailinglist: String
        },
        data() {
          
            const regex: RegExp = new RegExp("[^\w\d]*(([0-9]+.*[A-Za-z]+.*)|[A-Za-z]+.*([0-9]+.*))");
            const schema = yup.object({
                mc_username: yup.string().required(this.view_register_validate_requis).max(255, StringS.Format(this.view_register_validate_tropchars as string,255)),
                mc_password: yup.string().required(this.view_register_validate_requis).max(32, StringS.Format(this.view_register_validate_tropchars as string, 32)).min(8, StringS.Format(this.view_register_validate_minimumchars as string, 8)).matches(regex, this.view_register_validate_letternum),
                mc_passwordverif: yup.string().required(this.view_register_validate_requis).max(32, StringS.Format(this.view_register_validate_tropchars as string, 32)).min(8, StringS.Format(this.view_register_validate_minimumchars as string, 8)).matches(regex, this.view_register_validate_letternum).oneOf([yup.ref("mc_password")], this.view_register_validate_passdifferent),
                mc_email: yup.string().required(this.view_register_validate_requis).email(this.view_register_validate_emailinvalid).max(150, StringS.Format(this.view_register_validate_tropchars as string,150))
            });
            return {
                schema,
                registerpseudo: "",
                registerpassword: "",
                registerpasswordverif: "",
                registeremail: "",
                dcregisterstatut: "",
                isregistered: false,
                iserror: false,
                newsletter: false,
                nonce: "",
                signature: "",
                userFingerPrint: 0,
                applyButtonUsed: false,
                isInteractionDetected: false,
                honeyPotName: "",
                honeyPotValue: ""
            };
        },
        mounted() {
        },
        methods: {
            getFingerPrint() {
                const client = new ClientJS();
                this.userFingerPrint = client.getFingerprint();
            },

            handleValidationStatus(applyButtonUsedVal: boolean, isInteractionDetectedVal: boolean) {
                this.applyButtonUsed = applyButtonUsedVal;
                this.isInteractionDetected = isInteractionDetectedVal;
            },

            handleCaptchaReady(nonce: string, signature: string, honeyPotName: string, honeyPotValue: string) {
                this.nonce = nonce;
                this.signature = signature;
                this.honeyPotName = honeyPotName;
                this.honeyPotValue = honeyPotValue;
            },

            async CreateAnonymousAccountAndLogin() {
                await axios.post<boolean>("/api/v1/login/GenerateAndCheckLoginAnonymous");
                let url = new URL(window.location.href);
                const search = url.search;
                url = new URL(`${url.protocol}//${url.host}/cur/`);
                const params = new URLSearchParams(search);
                params.set('connect', '1');
                url.search = params.toString();
                window.location.href = url.toString();
            },

            OnSubmitAjax() {
                if (this.applyButtonUsed || !this.isInteractionDetected) {
                    return false;
                }

                this.getFingerPrint();

                if (this.langcurrent != null  && this.registerpseudo != null)
                    this.DCRegisterCompte(this.langcurrent, "/api/v1.0/login/RegisterPost", this.registerpseudo, this.registerpassword, this.registerpasswordverif, this.registeremail, this.newsletter, this.nonce, this.signature, this.userFingerPrint, this.honeyPotName, this.honeyPotValue);
            },

            DCRegisterCompte(lan: string, urlregister: string, username: string, password: string, passwordverif: string, email: string, newsletter: boolean, nonce: string, signature: string, userFingerPrint: number, honeyPotName: string, honeyPotValue: string) {
                //bootstrap.Modal.getInstance(elt)?.hide();
                let datapost: any = new Object();
                datapost['lan'] = lan;
                datapost['username'] = username;
                datapost['password'] = password;
                datapost['passwordverif'] = passwordverif;
                datapost['email'] = email;
                datapost['newsletter'] = newsletter;
                datapost['Nonce'] = nonce;
                datapost['Signature'] = signature;
                datapost['UserFingerPrint'] = userFingerPrint;
                datapost[honeyPotName] = honeyPotValue;
                let self = this;
                axios.post < DCRegisterResult>(urlregister, datapost).then(function (response: AxiosResponse<DCRegisterResult>) {
                    if (response.data != null) {
                        const isregister = response.data.isregister;
                        const errorregister = response.data.errorregister;
                        self.dcregisterstatut = errorregister;
                        self.isregistered = isregister;
                        self.iserror = !isregister;
                    }
                });
            }
        }
    });
